var exports = {
  "kL": "CollapsedCategoryVoiceParticipants.module__container___bXY3dm",
  "Kk": "CollapsedCategoryVoiceParticipants.module__icon___bXY3dm",
  "nU": "CollapsedCategoryVoiceParticipants.module__channelContainer___bXY3dm",
};

module.exports = exports;
